import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import favicon from "./assets/favicon.png";
import "./index.css";
import Root from "./Root";

const icon = document.createElement("link");
icon.rel = "icon";
icon.type = "image/png";
icon.href = favicon;
document.head.appendChild(icon);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
